import { analyticsDuckCreator } from 'axl-ducks';

export default analyticsDuckCreator({
    supportDomTagging: true,
});
